import React from 'react';
import clsx from 'clsx';

import { Link } from '@edx/components/link';
import { NavbarLinkProps } from '@edx/components/navbar/components/navbar-link/navbar-link';

export const MobileNavbarLink: React.FC<NavbarLinkProps> = ({ href, text, subMenu, isActive, onClick }) => (
  <li className="group" onClick={onClick}>
    <div className="relative flex justify-center pb-3">
      <Link href={href} className="text-white font-display uppercase text-3xl">
        {text}
      </Link>

      <div
        className={clsx(
          'absolute inset-x-0 bottom-0 mx-auto bg-gray-500 transition-all duration-200 ease-in-out h-2px',
          isActive ? 'w-8 bg-red-700' : 'w-0 group-hover:w-8'
        )}
      />
    </div>

    {subMenu?.length ? (
      <div className="w-72 mb-4 origin-top-right left-0 border-2 border-opacity-20 border-gray-500 rounded-md shadow-xs">
        <ul
          className="bg-gray-800 divide-gray-700 divide-y p-1 rounded-md text-center"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          {subMenu.map((menu) => (
            <li key={menu.href}>
              <Link
                href={menu.href}
                className="block duration-150 focus:outline-none font-body hover:bg-gray-700 leading-5 px-4 py-3 text-white transition"
              >
                {menu.text}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    ) : null}
  </li>
);
